import { EventEmitter, Injectable } from '@angular/core';
import { AccountListService } from './account-list.service';

@Injectable()
export class AccountListValidationService {
  constructor(private accountListService: AccountListService) {}
}
